import { Middleware, ResponseContext } from "@wingspanhq/wingspan-api-sdk";
import { sessionService } from "@services/sessionService";
import { tokenStore } from "@services/tokenStore";

export const authRefreshMiddleware: Middleware = {
  post: async (context: ResponseContext): Promise<Response | void> => {
    if (context.response.status !== 401) {
      return;
    }

    try {
      await sessionService.refreshAccessToken();
    } catch {
      tokenStore.clear();
      return;
    }

    const retryHeaders = new Headers(context.init.headers);
    retryHeaders.set(
      "Authorization",
      `Bearer ${tokenStore.getAccessToken() ?? ""}`
    );

    // Retried through context.fetch so the rest of the middleware chain still
    // applies to the new request.
    return context.fetch(context.url, {
      ...context.init,
      headers: retryHeaders
    });
  }
};
